// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__1qE1b","tab":"tabs_tab__eFzr9","active":"tabs_active__q7r5i"};